import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { chapterShape } from '../../../shapes/entities';

const ChapterSection = ({ chapter, userScore, achievableScore, children }) => {
  const { name } = chapter.attributes;

  return (
    <section className="o-section">
      <header className="solutions-grid--header">
        <h2 className="o-h3 t-text-weight--bold t-margin-small--bottom">
          {name}
        </h2>
        <FormattedMessage
          id="runs.show.solutions_grid.x_of_y_points"
          values={{
            x: userScore,
            y: achievableScore
          }}
        />
      </header>
      {children}
    </section>
  );
};

ChapterSection.propTypes = {
  chapter: chapterShape.isRequired,
  userScore: PropTypes.number.isRequired,
  achievableScore: PropTypes.number.isRequired,
  children: PropTypes.node
};
ChapterSection.defaultProps = {
  children: null
};

export default ChapterSection;
